import { Url } from '../shared/Url';
import Post from '../shared/Post';
import { cookieData } from '../funciones/ConsultaUser';

export const CheckCierre = (token, periodo, carrera, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            token: token,
            periodo: periodo,
            carrera: carrera
        }

        Post(`${Url}CheckCierre`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta (data)
        });
    });
}

export const SolicitarToken = (periodo, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            periodo: periodo
        }

        Post(`${Url}SolicitarToken`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta (data)
        });
    });
}

export const CierreInd = (est, periodo, respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1],
            est: est,
            periodo: periodo
        }

        Post(`${Url}CierreInd`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta (data)
        });
    });
}

export const FinCierre = (respuesta) => {
    cookieData((cookie) => {
        let Content = {
            uId: cookie[1]
        }

        Post(`${Url}FinCierre`, Content, (resp) => {
            let data = JSON.parse(resp)
            respuesta (data)
        });
    });
}


// WEBPACK FOOTER //
// ./src/funciones/CierreFunction.jsx